define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');

    ViewController.plugin({

        formatAsText: function (text, removeHtmlTags) {
            var div = document.createElement("DIV");
            if (removeHtmlTags) {
                text = this.removeHtmlTags(text);
            }
            var textNode = document.createTextNode(text);
            div.appendChild(textNode);
            text = div.innerText || div.textContent;
            div = null;
            return text;
        },
        removeHtmlTags: function (text) {
            var regex = /(<([^>]+)>)/ig;
            return text ? text.toString().replace(regex, "") : text;
        },
        formatTime: function (dateObj, withSeconds, type) {
            if (dateObj.constructor !== "Date") {
                dateObj = lpUtils.createDate(dateObj, type);
            }
            var time = ":";
            var timeMinutes = dateObj.getMinutes();
            time += timeMinutes < 10 ? "0" : "";
            time += timeMinutes;
            if (withSeconds) {
                var timeSeconds = dateObj.getSeconds();
                time += timeSeconds < 10 ? ":0" : ":";
                time += timeSeconds;
            }

        var hoursParsed = (dateObj.getHours() > 12 ? dateObj.getHours() - 12 : dateObj.getHours());
        hoursParsed = (hoursParsed === 0) ? 12 : hoursParsed;
        var ampm = (dateObj.getHours() > 11 ? "pm" : "am");
        return hoursParsed + time + ampm;
    },

        parseSecondsToTime: function (secs) {
            var t = new Date(1970, 0, 1);
            t.setSeconds(secs);
            var s = t.toTimeString().substr(3, 5);
            if (secs > 86399) {
                s = (Math.floor((t - Date.parse("1/1/70")) / 3600000) + s.substr(2));
            }
            return s;
        }
    });

    // todo - what to export?

});
